export const FooterColumn = (props) => {
  return (
    <>
      <div className="_display--inline-block _margin-right--10rem">
        <p className="_font-size--15px _color--var_text-primary_ _margin-bottom--1rem">
          {props.footerItem.footerTitle}
        </p>
        <ul className="_font-size--14px line-height--1-3">
          {props.footerItem.footerLinks.map((item, index) => (
            <li
              //className="_padding-bottom--10px"
              key={index}
            >
              <a
                className={item.externalLink ? "external_link" : ""}
                href={item.linkAnchor}
                target={item.externalLink ? "_blank" : ""}
                rel="noreferrer"
              >
                {item.linkText}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
